<template>
  <div
    id="tag-purchases"
  >
    <purchases
      :tagId="tagId"
    />

    <button
      class="btn btn-danger btn-block"
      v-on:click.prevent="deleteTagPurchases"
      v-if="this.$root.isDev"
    >
      Delete Tag Purchases
      <vue-spinner
        size="small"
        v-if="loading"
      ></vue-spinner>
    </button>
  </div>
</template>

<script>
import VueSpinner from 'vue-simple-spinner'

import Purchases from '@/components/Purchases'

import FlashStore from '@/stores/FlashStore'

export default {
  data () {
    return {
      loading: false
    }
  },

  props: {
    tagId: {
      type: String,
      default: undefined
    }
  },

  components: {
    'purchases': Purchases,
    'vue-spinner': VueSpinner
  },

  methods: {
    deleteTagPurchases () {
      if (confirm(
        'Are you sure you want to delete this tag\'s purchases? This action cannot be undone.'
      )) {
        this.loading = true

        this.$http.delete(
          this.apiUrl('/tags/' + this.tagId + '/purchases', true)
        ).then(() => {
          this.loading = false

          FlashStore.result('Tag pruchases deleted.')
        }, (resp) => {
          this.loading = false

          this.processErrors(resp)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TagPurchases.vue